import { INote, INoteSearchParam } from "../model/note";
import { IParticipation } from "../../summary/model/participation";
import { IPerson } from "../model/person";
import { ISeasonSummary } from "../model/seasonsummary";
import { ISportRoster } from "../../summary/model/sportroster";
import { ISportSeason } from "../model/sportseason";
import { ISportSeasonValidation } from "../model/sportseasonvalidation";
import { IDummyResponse, IStudent } from "../model/student";
import { ITransferHistory } from "../model/transferhistory";
import { ISearchParam } from "@app/modules/search/model/searchParam";
import { IStudentDocument } from "../model/studentdocument";
import { IStudentCourse } from "@app/modules/prospective/model/studentcourse";
import { ITestScoreData, ITestScoreListData } from "@app/modules/prospective/model/testscoredata";
import { IStudentHighSchool, IStudentHighSchoolScore, IStudentProspect } from "@app/modules/prospective/model/studenthighschool";
import { ICourseLookupInfo } from "@app/shared/model/lookup";
import { ERedShirtType } from "./eRedShirtType";
import { IStudentCertificationAcademicTermInstitutionCollegeHours } from "@app/modules/certification/model/studentcertificationacademicterminstitutioncollegehours";
import { IStudentCertificationAcademicTerm } from "@app/modules/certification/model/studentcertificationacademicterm";
import { IStudentExternalAcademicDatum } from "@app/modules/certification/model/studentexternalacademicdatum";
import { IStudentWorksheet } from "@app/modules/certification/model/studentworksheet";
import { IPageInfo } from "@app/shared/model/pageinfo";
import { IStudentWorksheetDiscipline } from "@app/modules/certification/model/studentworksheetdiscipline";
import { IStudentWorksheetSpring } from "@app/modules/certification/model/studentworksheetspring";
import { IStudentWorksheetGraduation } from "@app/modules/certification/model/studentworksheetgraduation";
import { IStudentCourseSnapshot } from "@app/modules/prospective/model/studentcoursesnapshot";
import { IOfficialVisit, IStudentOfficialVisitOccurence } from "../model/officialvisit";
import { ICostOfAttendance, ICostOfAttendanceRoomAndBoard } from "@app/modules/maintenance/model/costofattendance";
import { IStudentAnnualAthleticAid, IStudentFinancialAid, IStudentNonAthleticAid } from "@app/modules/financialaid/model/studentannualathleticaid";
import { IStudentAnnualSupplementalAid } from "@app/modules/financialaid/model/studentannualsupplementalaid";
import { IMaxValueParam } from "@app/modules/financialaid/model/maxValueParam";
import { IPersonAddress } from "@app/modules/shared/model/personaddress";
import { IPersonEmail } from "@app/modules/shared/model/personemail";
import { IPersonPhone } from "@app/modules/shared/model/personphone";
import { IApr, IStudentAprModel } from "@app/modules/apr/model/apr";
import { IStudentSearchResult } from "@app/modules/search/model/studentSearchResult";
import { IStudentProspectCertification } from "@app/modules/prospective/model/studentprospectcertification";
import { IReportParam } from "@app/modules/reports/model/reportparam";
import { IAdmissionStatusReportParam } from "@app/modules/reports/model/admissionStatusReportParam";
import { Guid } from "guid-typescript";
import { ISeasonNote } from "@app/modules/financialaid/model/seasonNote";
import { ICostOfMealPlan } from "@app/modules/maintenance/model/costofmealplan";
import { IStudentTermCourseEnrollment, IStudentTermCourseEnrollmentRegistration } from "@app/modules/certification/model/studenttermcourseenrollment";
import { IStudentExternalCourse } from "@app/modules/certification/model/studentexternalcourse";

export const emptyStudent = (): IStudent => ({
  studentId: null,
  personId: null,
  tenantId: null,
  institutionId: '',
  slateId: null,
  workdayId: null,
  academicRecordReferenceId:null,
  hasRecruitment: false,
  hasScholarship: false,
  hasImmunization: false,
  residenceId: 0,
  initialInstitutionTermId: null,
  initialTenantTermId: null,
  finalTenantTermId: null,
  fullTimeTransferTerms: null,
  withdrawalReasonId: null,
  exhaustedEligibilityTermId: null,
  nineHourWaiverTermId: null,
  declaredMajorTermId: null,
  intendedMajorId: null,
  intendedMajorDate: null,
  admissionStatusTypeId: null,
  classification: null,
  primarySport: null,
  lastSeason: null,
  isAddStudentByLsuId: false,
  person: emptyPerson(),
});

export const emptyDummyResponse = (): IDummyResponse => ({
  classification: '',
  admissions: '',
  onStudent: '',
});
export const emptyPerson = (): IPerson => ({
    personId: null,
    tenantId: null,
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    birthDate: new Date(""),
    sexId: 0,
    ncaaid: '',
    ssn: '',
    email: ''
});

export const emptySportSeason = (): ISportSeason => ({
  tenantId: null,
  studentId: null,
  studentInstitutionSeasonId: null,
  sportTypeId: null,
  sportSeasonId: null,
  ncaalegislationCode: '',
  isMedicalHardship: false,
  redShirtTypeId: ERedShirtType.N,
  isPrimarySport: false,
  isNinthSemester: false,
  hasLetter: false,
  squadComment: '',
  hasCertificationDocumentsOnFile: false,
  isSpringEnrollee: false,
  isPracticePlayer: false,
  fractionalAid: 0,
  fractionalAidExclusion: 0,
  exhaustedEligibilityTermId: null,
});

export const emptyTrasferHistory = (): ITransferHistory => ({
  tenantId: null,
  studentId: null,
  studentTransferSeasonId: null,
  sportTypeId: null,
  sportSeasonId: null,
  institutionId: null,
  institutionDescription: null,
  isMedicalHardship: false,
  isJuniorCollege: false,
  isJuniorCollegeGraduate: false
});

export const emptySeasonSummary = (): ISeasonSummary => ({
  id: null,
  studentId: null,
  firstName: '',
  lastName: '',
  middleName: '',
  institution: '',
  sportType: '',
  sportSeason: '',
  freshmanQualifierType: '',
  aidPercentage: null,
  hasSummerAid: false,
  eligibility: '',
  springEligibility: '',
  participation: '',
  aidExempt: '',
  isMedicalHardship: false,
  redShirtType: null,
  isNinthSemester: false
});

export const emptySportRoster = (): ISportRoster => ({
    studentInstitutionSeasonId: null,
    studentId: null,
    firstName: '',
    lastName: '',
    middleName: '',
    studentName: '',
    institutionId: '',
    sportType: '',
    sportSeason: '',
    enrollmentType: '',
    isNinthSemester: false,
    quitTeamDate: null,
    schoolStatus: '',
    fullPercentage: 0,
    participation: '',
    eligibility: '',
    financialAidCounter: '',
    exemptReason: '',
    totalPercentage: null,
});

export const emptyParticipation = (): IParticipation => ({
    studentInstitutionSeasonId: null,
    studentId: null,
    participationType: '',
    changeTypeId: 0,
    firstName: '',
    lastName: '',
    middleName: '',
    studentName: '',
    institutionId: '',
    hasLetter: false,
    quitTeamDate: null,
    sportType: '',
    sportSeason: '',
    fallEligibility: '',
    springEligibility: '',
    type: '',
});

export const emptyNotes = (): INote => ({
  tenantId: null,
  noteId: null,
  noteTypeId: null,
  studentId: null,
  content: '',
  noteType: '',
  updatedDate: new Date()
});

export const emptyNoteSearchParam = (): INoteSearchParam => ({
  noteTypeId: 0,
  userId: '',
  studentId: null
});

export const emptySearch = (): ISearchParam => ({
    studentId: null,
    name: '',
    sportTypeId: 0,
    sportSeasonId: 0,
    collegeId: 0,
    institutionId: '',
    workdayId: '',
    institutionTermId: 0,
});

export const emptySportSeasonValidation = (): ISportSeasonValidation => ({
  id: null,
  studentId: null,
  sportTypeId: 0,
  sportSeasonId: 0,
  isPrimarySport: false,
});
export const emptyStudentDocument = (): IStudentDocument => ({
    tenantId: null,
    studentId: null,
    studentDocumentId: null,
    documentTypeId: null,
    documentType: '',
    requestDate: new Date(),
    receiveDate: null,
    isOfficial: false,
    documentSourceTypeId: null,
    highSchoolInstitutionId: null,
    documentSourceType: '',
    description: '',
    // Below Properties took from old code
    actualFileName: '',
    fileName: '',
    extension: '',
    oldFileName: '',
    institutionDescription: '',
    highSchoolDescription: ''
});
export const emptyStudentCourse = (): IStudentCourse => ({
  tenantId: null,
  studentId: null,
  studentCourseId: null,
  courseTypeId: null,
  courseType: '',
  code: null,
  title: null,
  qualityPoints: null,
  units: null,
  points: null,
  gradeCode: '',
  isLab: false,
  isLocked: false,
  isChanged: false,
  showDelete: false,
  rowId:Guid.create().toJSON().value,
  action:'a',
});

export const emptyStudentCourseSnapshot = (): IStudentCourseSnapshot => ({
    studentCourseSnapshotId: null,
    tenantId: null,
    studentId: null,
    courses: '',
    tenBySeven: '',
    coreGpa: null,
    sattotal: null,
    acttotal: null,
    status: '',
    nextTranscript: '',
    notes: '',
    createdDate: null,
});

export const emptyTestScoreData = (): ITestScoreData => ({
  tenantId: null,
  studentId: null,
  studentExamId: null,
  examTypeId: null,
  examType: '',
  dateTaken: null,
  cancellationDate: null,
  approvalDate: null,
  status: null,
  isLocked: false,
  isOfficial: false,
  isValidationRequired: false,
  isTestingServiceRequired: false,
  isElectronicCopyReceieved: false,
  englishScore: null,
  mathScore: null,
  socialScienceScore: null,
  naturalScienceScore: null,
  verbalScore: null,
  writingScore: null,
  isToelfInternetBased: false,
  listeningScore: null,
  speakingScore: null,
  readingScore: null,
  quantitativeReasoningScore: null,
  totalScore: null,
});
export const emptyTestScoreListData = (): ITestScoreListData => ({
  studentId: null,
  examTypeId: null,
  examType: '',
  isHeader: false,
  column1: '',
  column2: '',
  column3: '',
  column4: '',
  column5: '',
  column6: '',
});


export const emptyStudentHighSchool = (): IStudentHighSchool => ({
  tenantId: null,
  studentId: null,
  studentHighSchoolId: null,
  highSchoolInstitutionId: null,
  highSchoolInstitutionCode: null,
  institutionDescription: null,
  isCurrent: false,
});

export const emptyStudentProspect = (): IStudentProspect => ({
  tenantId: null,
  studentId: null,
  studentProspectId: null,
  graduationDate: null,
  overallGpa: null,
  academicGpa: null,
  coreGpa: null,
  studentProspectAdmissionStatusTypeId: null,
  admissionStatusTypeId: null,
  admissionTermId: null,
  admissionInstitutionTermId: null,
  studentProspectAdmissionStatusType: '',
  admissionStatusType: '',
  admissionTerm: ''
});
export const emptyStudentHighSchoolScore = (): IStudentHighSchoolScore => ({
    studentId: null,
    courseCount: null,
    coreGPA: null,
    unitCount: null,
    units: null,
    grade: null,
    satTotal: null,
    actTotal: null,
    statusId: null,
    status: null,
    nextTranscript: null,
    notes: '',
});

export const emptyCourseLookupInfo = (): ICourseLookupInfo => ({
  id: null,
  description: null,
  unitCount: null,
  totalUnitCount: null,
  qualityPoints: null,
  studentCourse: []
});

export const emptyStudentHours = (): IStudentCertificationAcademicTermInstitutionCollegeHours => ({
  studentCertificationAcademicTermId: null,
  tenantId: null,
  studentId: null,
  studentName: null,
  institutionId: '',
  sport: '',
  classification: '',
  degreeProgram: '',
  degreeHoursAppliedAudit: 0,
  degreeHoursAppliedCollege: 0,
  percentage: 0,
  sportSeasonId: null,
  collegeName: '',
  hasEligibilitySet: false,
  institutionCollegeApprovalUserId: '',
  institutionCollegeApprovalDate: null
});

export const emptyStudentCertificationAcademicTerm = (): IStudentCertificationAcademicTerm => ({
  tenantId: null,
  studentId: null,
  studentCertificationAcademicTermId: null,
  institutionTermId: null,
  fullTimeTerm: null,
  fullTimeDayOne: null,
  fullTimeDayFourteen: null,
  institutionCollegeId: null,
  institutionCollegeApprovalDate: null,
  institutionCollegeApprovalUserId: null,
  majorDisciplineId: null,
  majorConcentrationId: null,
  minorDisciplineId: null,
  minorDiscipline2Id: null,
  minorDiscipline3Id: null,
  year: null,
  degreeHoursAppliedCollege: null,
  degreeHoursAppliedAudit: null,
  degreeHoursRequired: null,
  degreePercent: null,
  degreePercentBasis: null,
  institutionTerm: '',
  institutionCollege: '',
  classification: '',
});

export const emptyStudentExternalAcademicDatum = (): IStudentExternalAcademicDatum => ({
  tenantId: null,
  studentId: null,
  studentExternalAcademicDataId: null,
  transferrableCredits:null,
  twoYearTransferableCredits:null,
  gpaForTransferableCredits:null,
  earnedAssociatesDegree: null,
  twoYearInstitutionFullTimeTerms:null,
  apCredits:null,
  clepCredits:null,
  creditsEarnedPriorToFullTimeEnrollment:null,
});

export const emptyStudentTermCourseEnrollment = (): IStudentTermCourseEnrollment => ({
  tenantId: null,
  studentId: null,
  studentTermCourseEnrollmentId: null,
  institutionTermId: null,
  institutionTermDescription: null,
  totalCreditHoursAttempted: null,
  totalCreditHoursEarned: null,
  totalEarnedGradePoints: null,
  periodCreditHoursGpa: null,
  academicTermGpa: null,
  cumulativeCreditHoursAttempted: null,
  cumulativeCreditHoursEarned: null,
  cumulativeCreditHoursGpa: null,
  institutionGpa: null,
  institutionEarnedGradePoints: null,
  cumulativeCreditHoursAttemptedIncludingTransferCredit: null,
  cumulativeCreditHoursEarnedIncludingTransferCredit: null,
  cumulativeGPACreditHoursIncludingTransferCredit: null,
  cumulativeGPAIncludingTransferCredit: null,
  overallEarnedGradePoints: null,
  classification: null,
  academicStanding: null,
  lessThanFullTimeHoursNeedeToGraduate: null
});

export const emptyStudentTermCoursEnrollmentRegistration = (): IStudentTermCourseEnrollmentRegistration =>({
  tenantId: null,
  studentId: null,
  studentTermCourseEnrollmentId: null,
  studentTermCourseEnrollmentRegistrationId: null,
  transcriptGrade: null,
  courseSubjectNumber: null,
  courseDescription: null,
  overallRegistrationStatus: null,
  section: null,
  gradePoints: null,
  creditHours: null,
  earnedCreditHours: null,
  courseCode: null,
  interimGrade: null,
  majorCredit: null,
  minorCredit: null
});

export const emptyStudentExternalCourse = (): IStudentExternalCourse => ({
  tenantId: null,
  studentId: null,
  studentExternalCourseId: null,
  institutionTermId: null,
  institutionTermDescription: null,
  attemptedCreditHours: null,
  course: null,
  courseSubjectAndNumber: null,
  creditHours: null,
  earnedCreditHours: null,
  educationalInstitutionName: null,
  educationTest: null,
  educationTestSectionResult: null,
  gradedPoints: null,
  gradedDate: null,
  neededToSatisfyProgramOfStudy: false,
  registrationStartDate: null,
  transcriptGrade: null,
  transcriptLineAcademicPeriod: null,
  majorCredit: null,
  minorCredit: null
});

export const emptyStudentWorksheet = (): IStudentWorksheet => ({
  tenantId: null,
  studentId: null,
  studentCertificationWorksheetId: null,
  year: null,
  year1HoursEarned3S: null,
  year1Gpa3s: null,
  year1MajorForm: null,
  year1DegreeHoursEarned3S: null,
  year1Adst: null,
  hoursEarned1S: null,
  hoursEarned1T: null,
  hoursEarned2S: null,
  hoursEarned3S: null,
  degreeHoursEarned1S: null,
  degreeHoursEarned1T: null,
  degreeHoursEarned2S: null,
  degreeHoursEarned3S: null,
  gpa1s: null,
  gpa1t: null,
  gpa2s: null,
  gpa3s: null,
  sixHours1S: false,
  benchGpa1s: false,
  benchGpa1t: false,
  sixHours2S2t: false,
  eighteenHours2S2t: false,
  benchGpa3s3t: false,
  hoursPtd3s3t: false,
  oneEightHoursComments: null,
  twoFourHoursComments: null,
  certification1S1t: null,
  certification3S3t: null,
  nineHours1S1tMfb: false,
  twoSevenHours3SMfb: false,
});
export const emptyStudentWorksheetSpring = (): IStudentWorksheetSpring => ({
  studentCertificationWorksheetSpringId: null,
  tenantId: null,
  studentId: null,
  year: null,
  hoursEarned1S: null,
  hoursEarned1T: null,
  hoursEarned2S: null,
  hoursEarned3S: null,
  degreeHoursEarned1S: null,
  degreeHoursEarned1T: null,
  degreeHoursEarned2S: null,
  degreeHoursEarned3S: null,
  gpa1s: null,
  gpa1t: null,
  gpa2s: null,
  gpa3s: null,
  benchSixHours1S1t: false,
  benchOneEightHours1S1t: false,
  benchTwoFourHours1S1t: false,
  benchNineHours1S1tMfb: false,
  benchGpa1s1t: false,
  benchPtd1s1t: false,
  benchSixHours2S: false,
  benchMajorForm2S: false,
  benchOneEightHours2S: false,
  benchGpa2s: false,
  benchOneEightComments2S: null,
  benchOneEightComments1S1t: null,
  benchTwoFourComments1S1t: null,
  benchGpa3s: false,
  benchTwoSevenHours3SMfb: false,
  certification1S1t: '',
  certification3S3t: '',
});
export const emptyStudentWorksheetDiscipline = (): IStudentWorksheetDiscipline => ({
    tenantId: null,
    studentId: null,
    studentCertificationWorksheetDisciplineId: null,
    catalogYear: null,
    majorDisciplineId: null,
    majorConcentrationId: null,
    minorDisciplineId: null,
    institutionTermId: null,
    majorDiscipline: '',
    minorDiscipline: '',
    institutionTerm: '',
});
export const emptyStudentWorksheetGraduation = (): IStudentWorksheetGraduation => ({
  studentCertificationGraduationId: null,
  tenantId: null,
  studentId: null,
  graduationDate: null,
  quitTermDate: null,
});
export const emptyPageInfo = (): IPageInfo => ({
  pageNumber: 1,
  pageSize: 10,
  searchText: "",
  searchId: 0,
  orderBy: "",
  orderType: "",
});
export const emptyOfficialVisit = (): IOfficialVisit => ({
    tenantId: null,
    studentId: null,
    studentOfficialVisitId: null,
    highSchoolCounselor: '',
    transcriptRecievedDate: null,
    examTypeId: null,
    examScore: null,
    examDate: null,
    registeredNCAA: '',
    studentOfficialVisitOccurence: []
});

export const emptyOfficialVisitOccurence = (): IStudentOfficialVisitOccurence => ({
    studentOfficialVisitId: null,
    studentOfficialVisitOccurenceId: null,
    occurenceDate: null,
    occurenceReasonId: null,
    occurenceReason: ''
});

export const emptyCostOfAttendance = (): ICostOfAttendance => ({
    tenantId: null,
    costOfAttendanceId: null,
    institutionTermId: null,
    undergraduateResident: null,
    undergraduateNonResident: null,
    graduateResident: null,
    graduateNonResident: null,
    transportationInState: null,
    transportationOutOfState: null,
    booksAndSupplies: null,
    miscellaneous: null,
    costOfAttendanceRoomAndBoards: [],
    attendanceTotal: null,
    academicEnhancement: null,
    meals: null,
    recalculateFractionalAid: true,
    programTuition: null,
    graduateProgramTuition: null,
    nonResidentFee: null,
    graduateNonResidentFee: null
});

export const emptyCostOfAttendanceRoomAndBoard = (): ICostOfAttendanceRoomAndBoard => ({
    tenantId: null,
    costOfAttendanceId: null,
    costOfAttendanceRoomAndBoardId: null,
    housingTypeId: null,
    housingType: '',
    description: '',
    room: 0,
    board: 0
});

export const emptyCostOfMealPlan = (): ICostOfMealPlan => ({
  tenantId: null,
  costOfMealPlanId: null,
  institutionTermId: null,
  boardPlanTypeId: null,
  amount: 0,
  description: null,
});

export const emptyStudentFinancialAid = (): IStudentFinancialAid => ({
    fallStudentAnnualAthleticAid: emptyStudentAnnualAthleticAid(),
    springStudentAnnualAthleticAid: emptyStudentAnnualAthleticAid(),
    seasonYear: 0,
    fallGrandTotal: 0,
    springGrandTotal: 0,
    fractionalAid: 0,
    fallClassification:null,
    springClassification: null
});

export const emptyStudentAnnualAthleticAid = (): IStudentAnnualAthleticAid => ({
    tenantId: null,
    studentId: null,
    studentAthleticFinacialAidId: null,
    studentInstitutionSeasonId: null,
    institutionTermId: null,
    grant: null,
    percentage: null,
    fees: null,
    room: null,
    board: null,
    books: null,
    other: null,
    academicEnhancement: null,
    programTuition: null,
    nonResidentFee: null,
    costOfAttendanceRoomAndBoardId: null,
    boardPlanTypeId: null,
    grad: false,
    installment: true,
    pendingNotification: true,
    processDate: null,
    studentNonAthleticAids: []
});

export const emptyStudentNonAthleticAid = (): IStudentNonAthleticAid => ({
    tenantId: null,
    studentId: null,
    studentNonAthleticAidId: null,
    studentAthleticFinacialAidId: null,
    amount: null,
    type: '',
    nonAthleticFinancialAidCountableStatusId: null,
    showDelete: false,
    newRecord: true,
    index: 0,
});

export const emptyStudentAnnualSupplementalAid = (): IStudentAnnualSupplementalAid => ({
    tenantId: null,
    studentId: null,
    studentAnnualSupplementalAidId: null,
    institutionTermId: null,
    grant: 0,
    fees: 0,
    room: 0,
    board: 0,
    books: 0,
    other: 0,
    academicEnhancement:0,
    programTuition: 0,
    nonResidentFee: 0,
    housingTypeId: null,
    boardPlanTypeId: null,
    grad: false,
    installment: false,
    newRecord: true,
});

export const emptyMaxValueParam = (): IMaxValueParam => ({
    termId: null,
    costOfAttendanceRoomAndBoardId: null,
    isGraduate: null,
    studentId: Guid.createEmpty().toJSON().value,
});

export const emptyPersonAddress = (): IPersonAddress => ({
  tenantId: null,
  personId: null,
  personAddressId: null,
  addressTypeId: null,
  addressType: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  stateId: null,
  stateCode: '',
  provinceName: '',
  postalCode: '',
  countryCode: '',
});

export const emptyPersonEmail = (): IPersonEmail => ({
  tenantId: null,
  personId: null,
  personEmailId: null,
  emailTypeId: null,
  emailType: '',
  email: '',
});

export const emptyPersonPhone = (): IPersonPhone => ({
  tenantId: null,
  personId: null,
  personPhoneId: null,
  phoneTypeId: null,
  phoneType: '',
  phone: '',
  extension: '',
  isInternational: false,
});

export const emptyStudentAprModelSearch = (): IStudentAprModel => ({
    studentAcademicProgressRateId: null,
    statusId: null,
    type: '',
});

export const emptyApr = (): IApr => ({
    tenantId: null,
    studentId: null,
    studentAcademicProgressRateId: null,
    firstName: '',
    lastName: '',
    middleName: '',
    studentName:'',
    institutionId: '',
    workdayId: '',
    status:'',
    sportSeason:'',
    sportType:'',
    fallApreligibility:'',
    fallAprretention:'',
    springApreligibility:'',
    springAprretention:'',
    springEarnedPoints: 0,
    fallEarnedPoints:0,
    fallAprexclusionType:'',
    springAprexclusionType:'',
    sportSeasonId: null,
    sportTypeId: null,
    fallApreligibilityId: null,
    fallAprretentionId: null,
    fallAprexclusionTypeId: null,
    fallPossiblePoints: 0,
    springApreligibilityId: null,
    springAprretentionId: null,
    springAprexclusionTypeId: null,
    springPossiblePoints: 0,
    totalPossiblePoints:0,
    totalEarnedPoints: 0,
    sumOfFallEarnedPoints: 0,
    sumOfFallPossiblePoints: 0,
    sumOfSpringEarnedPoints: 0,
    sumOfSpringPossiblePoints: 0,
    sumOfTotalEarnedPoints: 0,
    sumOfTotalPossiblePoints: 0,
    isShowFallElgDropdown:true,
    isShowSpringElgDropdown:true,
    isShowFallRetDropdown:true,
    isShowSpringRetDropdown:true
});

export const emptyStudentSearchResult = (): IStudentSearchResult => ({
    studentId: null,
    personId: null,
    tenantId: null,
    institutionId: '',
    workdayId: '',
    firstName: '',
    middleName: '',
    lastName: '',
    primarySport: '',
    lastSeason: '',
    collegeName: '',
    classification: '',
    degreeProgram: '',
    degreeHoursAppliedAudit: '',
    collegeHours: '',
    Percentage: null,
    sportTypeId: null,
    sportSeasonId: null
});

export const emptyStudentProspectCertification = (): IStudentProspectCertification => ({
  studentProspectId: null,
  studentProspectCertificationId: null,
  englishUnits: null,
  englishQualityPoints: null,
  mathematicsUnits: null,
  mathematicsQualityPoints: null,
  naturalScienceUnits: null,
  naturalScienceQualityPoints: null,
  socialScienceUnits: null,
  socialScienceQualityPoints: null,
  additionalUnits: null,
  additionalQualityPoints: null,
  academicCreditsUnits: null,
  academicCreditsQualityPoints: null,
  coreGpa: null,
  enactsum: null,
  enactcomposit: null,
  isEnactcompositeAveraged: false,
  sattotal: null,
  isSattotalAveraged: false,
  hasRsat: false,
  hasRsatpre2016: false,
  satpre1995: null,
  isSatpre1995Averaged: false,
  actpre1990: null,
  isActpre1990: false
});
export const emptyReportParam = (): IReportParam => ({
    startDate: null,
    endDate: null
});

export const emptyAdmissionStatusReportParam = (): IAdmissionStatusReportParam => ({
  sportSeasonId: null,
  sportTypeId: null,
  studentId: null
});

export const emptySeasonNotes = (): ISeasonNote => ({
  tenantId: null,
  studentId: null,
  seasonNoteId: null,
  sportSeasonId: null,
  sportSeason:'',
  content: '',
});
